import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { FooterSection } from "@/components/landing/FooterSection";
import { AddLinkForm } from "@/components/landing/AddLinkForm";
import { LinksDisplay } from "@/components/landing/LinksDisplay";
import { RecentLinks } from "@/components/landing/RecentLinks";

const Index = () => {
  const [links, setLinks] = useState<any[]>([]);
  const { toast } = useToast();

  const handleAddLink = async (linkData: any) => {
    try {
      const { data, error } = await supabase
        .from("marketplace_links")
        .insert({
          ...linkData,
          user_id: null,
        })
        .select();

      if (error) throw error;

      if (data) {
        setLinks([data[0], ...links]);
      }
      return true;
    } catch (error) {
      throw error;
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow bg-gradient-to-b from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20">
        <HeroSection />
        <AddLinkForm onSubmit={handleAddLink} />
        <LinksDisplay links={links} />
        <RecentLinks key={links.length} />
        <FeaturesSection />
        <FooterSection />
      </div>
    </div>
  );
};

export default Index;